import { getApiBaseUrl } from "../config/appSettings";

export function resolveMediaUrl(value) {
  if (typeof value !== "string") return "";
  const path = value.trim();
  if (!path) return "";
  if (/^(https?:)?\/\//i.test(path) || path.startsWith("data:") || path.startsWith("blob:")) {
    return path;
  }

  const baseUrl = getApiBaseUrl();
  if (!baseUrl) return path;
  return `${baseUrl}${path.startsWith("/") ? path : `/${path}`}`;
}
